import { FC } from "react"

const FormPage: FC = () => {
  return <></>;
};

export default FormPage;
